// PresentationIcon.jsx

import React from 'react';

/**
 * PresentationIcon
 *
 * @returns {ReactNode} The rendered component.
 */
const PresentationIcon = React.memo(({ width = 24, height = 24, ...rest }) => {

  // ----- RENDER ----- //

  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      style={{
        opacity: 0.2,
      }}
      d="m 14.5,7.9999996 c -1.385,0 -2.5,1.115 -2.5,2.5000004 v 45 c 0,1.385 1.115,2.5 2.5,2.5 h 35 C 50.885,58 52,56.885 52,55.5 V 23 L 38.25,21.75 37,7.9999996 Z"
    />
    <path fill="#ff5722" d="m14.5 7c-1.385 0-2.5 1.115-2.5 2.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5v-32.5l-13.75-1.25-1.25-13.75z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="M 37,7.9999996 V 20.5 c 0,1.3808 1.1193,2.5 2.5,2.5 H 52 Z"
    />
    <path fill="#ff8660" d="m37 7v12.5c0 1.3808 1.1193 2.5 2.5 2.5h12.5l-15-15z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="m 25,33 c -2.7614,0 -5,2.2386 -5,5 0,2.7614 2.2386,5 5,5 2.7614,0 5,-2.2386 5,-5 h -5 z m 7,0 v 3 h 11 v -3 z m 0,6 v 3 h 11 v -3 z m -12,6 v 3 h 18 v -3 z"
    />
    <path fill="#fff" d="m25 32c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5h-5zm7 0v3h11v-3zm0 6v3h11v-3zm-12 6v3h18v-3z" />
    <path
      style={{
        fill: '#ffffff',
        opacity: 0.1,
      }}
      d="m 14.5,6.9999996 c -1.385,0 -2.5,1.115 -2.5,2.5 V 10.5 C 12,9.1149996 13.115,7.9999996 14.5,7.9999996 H 37 c 0,-1 0,0 0,-1 z"
    />
  </svg>
  );
});

// Dev Tools
PresentationIcon.displayName = 'PresentationIcon';

export default PresentationIcon;
